import React from 'react'

import { IProductTemplateAttribute } from 'components/dashboard/product-template-table/utils/interfaces';
import { Chips, ChipsChangeEvent } from 'primereact/chips';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { CellSubType } from 'utils/enums';
import { TimeSpan } from 'utils/time-utils';
import { T } from "services/lang/LanguageService";

type MultiValueTypeProps = {
	attribute: IProductTemplateAttribute;
	onAttributeChange: React.Dispatch<
		React.SetStateAction<IProductTemplateAttribute>
	>;
};

const MultiValueType: React.FC<MultiValueTypeProps> = ({attribute, onAttributeChange}) => {
  const onFieldChange = (e: ChipsChangeEvent | DropdownChangeEvent) => {
    let { value } = e.target;

    if (attribute.subType === CellSubType.TIMESPAN && e.target.name === "selectionValues") {
      value = value?.map((v: string) => parseTimeSpan(v));
    }

    onAttributeChange(prev => ({
			...prev,
			[e.target.name]: value,
		}))
  }

  const handleChipTemplate = (item: string) => {
    const timeSpan = parseTimeSpan(item);
    return getTimeSpanStringTemplate(timeSpan);
  }

  const parseTimeSpan = (string: string): TimeSpan => {
    const times = string?.split(':');
    const days = parseInt(times[0], 10) || 0;
    const hours = parseInt(times[1], 10) || 0;
    const minutes = parseInt(times[2], 10) || 0;
    const seconds = parseInt(times[3], 10) || 0;
    return { days, hours, minutes, seconds };
  }

  const getTimeSpanStringTemplate = (timeSpan: TimeSpan) => {
    return `${timeSpan.days}d ${timeSpan.hours}h ${timeSpan.minutes}m ${timeSpan.seconds}s`;
  }

  const selections = attribute.selectionValues?.map(sv =>
    typeof sv !== "string" ? `${sv.days}:${sv.hours}:${sv.minutes}:${sv.seconds}` : sv
  );

  const chipProps = {
    value: selections ?? [],
    onChange: onFieldChange,
    name: "selectionValues",
    separator: ",",
    disabled: !attribute.subType,
  };

  return (
    <>
      <div className="p-field p-col-2">
        <label>{T("word.subtype")}</label>
        <Dropdown
          value={attribute.subType}
          options={Object.keys(CellSubType)}
          onChange={onFieldChange}
          name="subType"
        />
      </div>
      <div className="p-field p-col-10">
        <label>{T("word.selection-values")}</label>
        {attribute.subType === CellSubType.TIMESPAN ? (
          <Chips
            {...chipProps}
            placeholder="Timespans use 0:0:0:0 format (days:hours:minutes:seconds)"
            itemTemplate={handleChipTemplate}
          />
        ) : (
          <Chips {...chipProps} />
        )}
      </div>
    </>
  );
}

export default MultiValueType